import React from "react";
import Slider from "react-slick";
import logo1 from "../resources/carLogo/carlogo (1).svg";
import logo2 from "../resources/carLogo/carlogo (2).svg";
import logo3 from "../resources/carLogo/carlogo (3).svg";
import logo4 from "../resources/carLogo/carlogo (4).svg";
import logo5 from "../resources/carLogo/carlogo (5).svg";
import logo6 from "../resources/carLogo/carlogo (6).svg";
import logo7 from "../resources/carLogo/carlogo (7).svg";
import logo8 from "../resources/carLogo/carlogo (8).svg";
import logo9 from "../resources/carLogo/carlogo (9).svg";
import logo10 from "../resources/carLogo/carlogo (10).svg";

function LogoSlider() {
  const images = [
    { src: logo1, alt: "Car Logo" },
    { src: logo2, alt: "Model S" },
    { src: logo3, alt: "Car Logo" },
    { src: logo4, alt: "Car Logo" },
    { src: logo5, alt: "Car Logo" },
    { src: logo6, alt: "Car Logo" },
    { src: logo7, alt: "Car Logo" },
    { src: logo8, alt: "Car Logo" },
    { src: logo9, alt: "Car Logo" },
    { src: logo10, alt: "Car Logo" },
  ];

  var settings = {
    infinite: true,
    speed: 5000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    autoplaySpeed: 0,
    pauseOnHover: false,
    arrows: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="relative">
      {/* Gradient fades on sides */}
      <div className="absolute left-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-r from-zinc-50 to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-l from-zinc-50 to-transparent z-10 pointer-events-none"></div>

      <Slider {...settings}>
        {images.map((image, idx) => (
          <div key={idx} className="px-6">
            <img
              src={image.src}
              alt={image.alt}
              className="w-16 h-16 md:w-20 md:h-20 opacity-40 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-500 mx-auto"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default LogoSlider;
